(function () {
  var hero = document.querySelector('body.index #template--21637687410942__slideshow_HL3TmB .sec__inner');

  if (!hero || !window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var bounds = null;
  var raf = 0;
  var targetX = 0;
  var targetY = 0;

  function readBounds() {
    bounds = hero.getBoundingClientRect();
  }

  function writeMotionVars() {
    raf = 0;
    hero.style.setProperty('--jw-fabric-x', targetX.toFixed(2) + 'px');
    hero.style.setProperty('--jw-fabric-y', targetY.toFixed(2) + 'px');
    hero.style.setProperty('--jw-gloss-x', (targetX * 3.2).toFixed(2) + 'px');
  }

  function scheduleWrite() {
    if (!raf) {
      raf = window.requestAnimationFrame(writeMotionVars);
    }
  }

  function handlePointerMove(event) {
    if (!bounds) {
      readBounds();
    }

    var centerX = bounds.left + bounds.width / 2;
    var centerY = bounds.top + bounds.height / 2;
    var x = (event.clientX - centerX) / Math.max(bounds.width, 1);
    var y = (event.clientY - centerY) / Math.max(bounds.height, 1);

    targetX = Math.max(-1, Math.min(1, x)) * 12;
    targetY = Math.max(-1, Math.min(1, y)) * 8;
    scheduleWrite();
  }

  function resetMotion() {
    targetX = 0;
    targetY = 0;
    scheduleWrite();
  }

  readBounds();
  window.addEventListener('resize', readBounds, { passive: true });
  hero.addEventListener('pointermove', handlePointerMove, { passive: true });
  hero.addEventListener('pointerleave', resetMotion, { passive: true });
})();
